var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgToolsBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000001268"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 39418",
    y: 0.5,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 39419",
    x: 10,
    y: 0.5,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 39420",
    x: 10,
    y: 10.5,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 39421",
    y: 10.5,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#1D1D1D"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToolsBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tools-black.a4d26948e68a520bff34cc5d5cb97048.svg";